<template>
  <div class="streamer">
    <div class="streaming-container">
      <div class="video-container">
        <video id="videoContent" ref="videoContent" autoplay muted playsinline></video>

        <template v-if="pushing">
          <div class="livedata-tips" @click="showLiveData = !showLiveData">直播数据</div>

          <div class="livedata-container" v-if="showLiveData">
            <div>
              <div>进房人数</div>
              <div>{{ LiveData.enterCount }}</div>
            </div>
            <div>
              <div>拉流人数</div>
              <div>{{ LiveData.timeCount }}</div>
            </div>
            <div>
              <div>评论人数</div>
              <div>{{ LiveData.commentCount }}</div>
            </div>
            <div>
              <div>跳失率</div>
              <div>{{ LiveData.redirectCount }}</div>
            </div>
          </div>

          <div class="live-indicator">
            <div class="live-status">直播中</div>
            <span @click="handleclearKeepLive">
              手动清除缓存
            </span>
          </div>

          <div class="right-menu">
            <span class="viewer-count">{{ online_count }} 人在线</span>
            <span class="icon" @click="endLiveHandle">
              <img src="../assets/close.svg" alt="" style="width: 25px;height: 25px;">
            </span>
          </div>

          <div class="switch-icon">
            <span class="icon" @click="switchCamera">
              <img src="../assets/camera.svg" alt="" />
            </span>
          </div>

          <div class="chat-container" v-if="roomId">
            <DanmakuPanel url="wss://danmuadmin.wokfoy.com:9982" :room-id="roomId" :token="token" />
          </div>
        </template>

        <template v-else>
          <div class="live-menu-top">
            <div class="live-info">
              <router-link to="/">
                <span class="icon">
                  <img src="../assets/arrow-left.svg" alt="">
                </span>
              </router-link>
              <span class="liver-avatar">G</span>
              <span>Green bag store</span>
            </div>
            <div class="media-setting">
              <span></span>
              <span class="button-icon" @click="switchCamera">
                <img src="../assets/camera.svg" alt="" />
              </span>
              <span class="button-icon" @click="swicthAudioTrack">
                <img v-if="openAudioTrack" src="../assets/mic-on.svg" alt="" />
                <img v-else src="../assets/mic-off.svg" alt="" />
              </span>
            </div>
          </div>

          <div class="live-menu-bottom">
            <input type="text" placeholder="直播主题，开启直播" class="live-title-input" v-model="liveTitle" />
            <button @click="goLive">开始直播</button>
            <button @click="handleclearKeepLive" style="background-color:#222;">手动清除缓存</button>
          </div>
        </template>


        <Countdown321 ref="countdown" :size="240" color="#ccc" @finished="onFinished" />
        <div class="countdown-box" v-show="restartComfirm">
          <div>{{ restartTime + 's后将关闭直播' }}</div>
          <div class="countdown-btn" style="background-color:aquamarine;" @click="initRestartTimer">恢复直播</div>
          <div class="countdown-btn" style="background-color: #ff0000;" @click="endLiveHandle">关闭直播</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo, createStream, changeLiveStatus, getLiveData, liveroomsList } from '../api/index'
import DanmakuPanel from '../components/Danmaku.vue'
import {
  formatTime,
  preferMobileH264,
  forceH264Baseline,
  preferOpus,
  setKeepLive,
  getKeepLive,
  clearKeepLive,
} from '../utils/common'
import { getToken } from '../utils/auth'
import Countdown321 from "../components/countdown321.vue";

export default {
  name: 'Streamer',
  components: { DanmakuPanel, Countdown321 },
  data() {
    return {
      roomId: null,
      chatInput: '',
      loading: false,
      isStreaming: false,

      // 本地媒体流（注意：只保留一处声明，避免重复）
      stream: null,

      openAudioTrack: true,
      pushing: false,
      state: '',
      liveTitle: 'Green bag Store',

      // 会话持久化
      sessionKey: 'bitlive_push_session_v1',
      userTerminated: false,

      // 设备
      videoInputs: [],
      audioInputs: [],
      selectedCam: '',
      selectedMic: '',
      resolution: 720,
      fps: 30,
      kbps: 2000,
      audioKbps: 64,
      noiseSuppression: true,
      echoCancellation: true,
      autoGain: false,

      // WebRTC
      currentFacing: 'user',
      frontCamId: null,
      backCamId: null,
      pc: null,
      videoSender: null,
      audioSender: null,
      statsTimer: null,

      // 防并发/竞态
      startToken: 0,

      // WHIP
      whipUrl: '/whip',
      auth: '', // webrtc://...
      whipResource: '',
      _whipInFlight: false,
      _whipCompleted: false,

      // ICE
      iceText: 'stun:stun.l.google.com:19302',
      forceRelay: true,

      // 直播数据
      visitDataTimer: null,
      showLiveData: false,
      LiveData: {
        enterCount: 88,
        timeCount: 88,
        commentCount: 88,
        redirectCount: 11
      },
      online_count: 0,

      // 稳态
      retryTimer: null,
      retryCount: 0,
      maxRetry: 6,
      baseBackoffMs: 1200,
      lastGoodBitrateTs: 0,
      zeroBitrateSince: 0,
      appid: 1,

      restartComfirm: false,
      restartTime: 120,
      restartTimer: null,
    }
  },
  computed:{
    iceServers() {
      const trimmed = (this.iceText || '').trim();
      if (!trimmed) return [{ urls: 'stun:stun.l.google.com:19302' }];
      const parts = trimmed.split(',').map(s => s.trim()).filter(Boolean);
      return parts.map(entry => {
        // 带凭据形式：url|username|credential
        if (entry.startsWith('turn:') && entry.includes('|')) {
          const [url, username, credential] = entry.split('|');
          return { urls: url, username: (username || '').trim(), credential: (credential || '').trim() };
        }
        return { urls: entry };
      });
    },
    rtcConfig() {
      return {
        iceServers: this.iceServers,
        // 关键点：只允许 relay（TURN），不使用 host/srflx 直连
        iceTransportPolicy: this.forceRelay ? 'relay' : 'all',
        bundlePolicy: 'max-bundle',
        rtcpMuxPolicy: 'require',
        iceCandidatePoolSize: 0,
      };
    },
    token() {
      return this.$store.getters.token || localStorage.getItem('lvtu_live_apitoken') || getToken()
    },
  },
  async mounted() {
    if (this.appid == 1) {
      let { data } = await getUserInfo()
      this.appid = data.appid
    }
    this.enumerate()
    await this.startLocalStream('user')
    await this.buildCameraMap();

    window.addEventListener('online', this.onOnline, { passive: true });
    window.addEventListener('offline', this.onOffline, { passive: true });
    window.addEventListener('pageshow', this.onPageShow, { passive: true });
    document.addEventListener('visibilitychange', this.onVisibility, { passive: true });
    window.addEventListener('beforeunload', this.onBeforeUnload, { passive: true });

    // 进入页面尝试自动续推
    this.autoResume();
    // this.visitDataTimer = setInterval(async () => {
    //   const res = await fetch('https://streamer.wokfoy.com/visit_live_data/latest', {
    //     method: 'GET',
    //     cache: 'no-store'
    //   });
    //   const { data } = await res.json()
    //   this.online_count = data?.online_user_count || 0
    // }, 3000)
  },
  beforeDestroy() {
    window.removeEventListener('online', this.onOnline);
    window.removeEventListener('offline', this.onOffline);
    window.removeEventListener('pageshow', this.onPageShow);
    document.removeEventListener('visibilitychange', this.onVisibility);
    window.removeEventListener('beforeunload', this.onBeforeUnload);
    this.cancelRestart?.();
    // if (this.visitDataTimer) {
    //   clearInterval(this.visitDataTimer)
    //   this.visitDataTimer = null
    // }
  },
  methods: {
    async setRestartTimer() {
      if (this.restartTimer) return
      this.restartTimer = setInterval(async () => {
        this.restartTime--
        this.restartComfirm = true
        if (this.restartTime <= 0) {
          clearInterval(this.restartTimer)
          this.initRestartTimer()
          // 只在明确结束时，清掉“要继续推”的标记
          clearKeepLive();

          try { await changeLiveStatus({ stream_name: this.roomId, stream_status: 2 }); } catch (_) { }

          this.cancelRestart?.();
          await this.stopPush({ terminate: true });

          this.startLocalStream?.();
        }
      }, 1000)
    },
    initRestartTimer() {
      if (this.restartTimer) {
        clearInterval(this.restartTimer)
      }
      this.restartTime = 120
      this.restartTimer = null
      this.restartComfirm = false
    },
    async getCurentLiveData(stream_name) {
      const start_time = formatTime(new Date().getTime() - 1 * 24 * 60 * 60 * 1000);
      const end_time = formatTime(new Date().getTime());
      let { data } = await getLiveData(
        stream_name,
        start_time,
        end_time
      )
      console.log(data)
      // this.LiveData = data
    },
    async handleclearKeepLive() {
      clearKeepLive();

      this.cancelRestart?.();
      await this.stopPush({ terminate: true });

      this.startLocalStream?.();
    },
    // —— 稳态 & 恢复 —— //
    onOnline() {
      if (!this.pushing && !this._whipInFlight) this.autoResume?.();
      else this.tryKick?.();
    },
    onOffline() { /* 不清理，等待恢复 */ },
    onPageShow() {
      console.log('onPageShow')
      this.cancelRestart();
      this.autoResume?.();
    },
    onVisibility() {
      if (this.pushing) {
        this.setRestartTimer()
      }
      if (document.hidden) {
        // 隐藏时只保存快照，不停播
        this.saveSession({
          auth: this.auth,
          roomId: this.roomId,
          whipResource: this.whipResource,
          pushing: this.pushing,
          userTerminated: false,
        });
        return;
      }
      this.autoResume();
    },
    onBeforeUnload() {
      // 页面刷新/关闭：只保存快照，不停播
      this.saveSession({
        auth: this.auth,
        roomId: this.roomId,
        whipResource: this.whipResource,
        pushing: this.pushing,
        userTerminated: false,
      });
    },
    async autoResume() {
      let { data } = await liveroomsList(15, 1)
      let living = data.data.find(f => f.status == 1)
      const sess = this.loadSession();
      if (!living && living?.stream != sess.roomId) return
      if (!getKeepLive()) return;
      if (this.pushing || this._whipInFlight) return;

      if (!this.stream || !this.stream.getTracks || this.stream.getTracks().length === 0) {
        try { await this.startLocalStream?.(); } catch (_) { }
      }
      try { await this.startPush(); } catch (_) { }
    },
    async tryKick() {
      try { this.pc?.getSenders?.().forEach(s => s?.transport); } catch (_) { }
      try { await this.$refs.videoContent?.play?.(); } catch (_) { }
    },
    scheduleRestart(reason = '') {
      if (!getKeepLive()) return;
      if (this._whipInFlight || this.retryTimer) return;

      const delay = Math.min(this.baseBackoffMs * Math.pow(2, this.retryCount), 15000);
      console.warn('[WHIP][restart]', reason, `in ${delay}ms`);
      this.retryTimer = setTimeout(async () => {
        this.retryTimer = null;
        this.retryCount = Math.min(this.retryCount + 1, this.maxRetry);
        await this.stopPush({ terminate: false });
        await this.startPush();
        if (this.pushing) this.retryCount = 0;
      }, delay);
    },
    cancelRestart() {
      if (this.retryTimer) clearTimeout(this.retryTimer);
      this.retryTimer = null;
      this.retryCount = 0;
    },

    // —— 设备与本地流 —— //
    async enumerate() {
      try { await navigator.mediaDevices.getUserMedia({ audio: true, video: true }); } catch (_) { }
      const devices = await navigator.mediaDevices.enumerateDevices();
      this.videoInputs = devices.filter(d => d.kind === 'videoinput');
      this.audioInputs = devices.filter(d => d.kind === 'audioinput');
      if (!this.selectedCam && this.videoInputs[0]) this.selectedCam = this.videoInputs[0].deviceId;
      if (!this.selectedMic && this.audioInputs[0]) this.selectedMic = this.audioInputs[0].deviceId;
    },
    async buildCameraMap() {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const vids = devices.filter(d => d.kind === 'videoinput');
        const back = vids.find(d => /back|rear|environment/i.test(d.label));
        const front = vids.find(d => /front|user|face/i.test(d.label)) || vids[0];
        this.frontCamId = front?.deviceId || null;
        this.backCamId = back?.deviceId || null;
      } catch (e) {
        console.warn('enumerateDevices failed:', e);
      }
    },
    async startLocalStream(facing = this.currentFacing) {
      if (this.stream) {
        this.stream.getTracks().forEach(t => t.stop());
        this.stream = null;
      }
      const preferDeviceId =
        facing === 'environment' ? this.backCamId :
          facing === 'user' ? this.frontCamId : null;

      const baseVideo = {
        width: { ideal: 1280, max: 1280 },
        height: { ideal: 720, max: 720 },
        frameRate: { ideal: 30, max: 30 },
      };
      const tries = [
        preferDeviceId ? { video: { ...baseVideo, deviceId: { exact: preferDeviceId } }, audio: true } : null,
        { video: { ...baseVideo, facingMode: { exact: facing } }, audio: true },
        { video: { ...baseVideo, facingMode: facing }, audio: true },
      ].filter(Boolean);

      let lastErr;
      for (const c of tries) {
        try { this.stream = await navigator.mediaDevices.getUserMedia(c); break; }
        catch (e) { lastErr = e; }
      }
      if (!this.stream) throw lastErr || new Error('无法打开摄像头');

      const v = this.$refs.videoContent || document.querySelector('video');
      if (v) {
        v.srcObject = this.stream;
        v.muted = true;
        await v.play().catch(() => { });
        // v.style.transform = (facing === 'user') ? 'scaleX(-1)' : 'none';
      }
      this.currentFacing = facing;

      // 正在推流 → 热切换轨道
      const newVideoTrack = this.stream.getVideoTracks()[0];
      if (this.videoSender && newVideoTrack) {
        try { this.videoSender.track?.stop?.(); } catch (_) { }
        await this.videoSender.replaceTrack(newVideoTrack).catch(() => { });
        this.applySenderParams?.();
      }
    },
    async switchCamera() {
      this.currentFacing = (this.currentFacing === 'user') ? 'environment' : 'user';
      try {
        const newStream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: this.currentFacing, frameRate: { ideal: this.fps, max: this.fps } },
          audio: false
        });
        const newVideo = newStream.getVideoTracks()[0];
        const old = this.stream?.getVideoTracks?.()[0];
        if (old) old.stop();
        const vlist = this.stream.getVideoTracks();
        if (vlist[0]) this.stream.removeTrack(vlist[0]);
        this.stream.addTrack(newVideo);
        await this.videoSender?.replaceTrack(newVideo);
      } catch (e) {
        console.warn('switchCamera failed, fallback restart', e);
        this.scheduleRestart('switch camera failed');
      }
    },
    swicthAudioTrack() {
      const audioTrack = this.stream.getAudioTracks()[0]
      audioTrack.enabled = !this.openAudioTrack
      this.openAudioTrack = !this.openAudioTrack
    },

    // —— WebRTC/WHIP —— //
    createPC() {
      this.pc = new RTCPeerConnection({iceServers: this.iceServers})
      this.pc.onconnectionstatechange = () => {
        this.pcState = this.pc.connectionState;
        if (this.pcState === 'failed') this.scheduleRestart('pc failed');
      };
      this.pc.oniceconnectionstatechange = () => {
        this.iceState = this.pc.iceConnectionState;
        if (this.iceState === 'failed') this.scheduleRestart('ice failed');
      };

      const vTrack = this.stream?.getVideoTracks?.()[0];
      const aTrack = this.stream?.getAudioTracks?.()[0];
      if (!vTrack && !aTrack) throw new Error('没有可用的本地媒体轨道');

      const vTrans = vTrack && this.pc.addTransceiver(vTrack, { direction: 'sendonly' });
      const aTrans = aTrack && this.pc.addTransceiver(aTrack, { direction: 'sendonly' });

      this.videoSender = vTrans?.sender || (vTrack && this.pc.addTrack(vTrack, this.stream));
      this.audioSender = aTrans?.sender || (aTrack && this.pc.addTrack(aTrack, this.stream));

      if (vTrans) preferMobileH264(vTrans);
      if (aTrans) preferOpus(aTrans);

      this.applySenderParams?.();
    },
    async applySenderParams() {
      // video
      if (this.videoSender && this.videoSender.getParameters) {
        try {
          const p = this.videoSender.getParameters() || {};
          // 兼容 encodings 为 undefined 或 空数组
          if (!p.encodings || !Array.isArray(p.encodings) || p.encodings.length === 0) {
            p.encodings = [{}];
          }
          const enc = p.encodings[0] || (p.encodings[0] = {});
          enc.maxBitrate = Math.max(64_000, (this.kbps | 0) * 1000);
          enc.maxFramerate = this.fps;
          await this.videoSender.setParameters(p).catch(() => { });
        } catch (e) {
          console.warn('[applySenderParams][video] skip:', e);
        }
      }

      // audio
      if (this.audioSender && this.audioSender.getParameters) {
        try {
          const ap = this.audioSender.getParameters() || {};
          if (!ap.encodings || !Array.isArray(ap.encodings) || ap.encodings.length === 0) {
            ap.encodings = [{}];
          }
          const aenc = ap.encodings[0] || (ap.encodings[0] = {});
          aenc.maxBitrate = Math.max(16_000, (this.audioKbps | 0) * 1000);
          await this.audioSender.setParameters(ap).catch(() => { });
        } catch (e) {
          console.warn('[applySenderParams][audio] skip:', e);
        }
      }
    },
    waitIceComplete() {
      return new Promise(resolve => {
        if (!this.pc) return resolve();
        if (this.pc.iceGatheringState === 'complete') return resolve();
        const onState = () => {
          if (this.pc.iceGatheringState === 'complete') {
            this.pc.removeEventListener('icegatheringstatechange', onState);
            resolve();
          }
        };
        this.pc.addEventListener('icegatheringstatechange', onState);
        setTimeout(() => resolve(), 2500);
      });
    },
    attachTrackMonitors() {
      const v = this.stream?.getVideoTracks?.()[0];
      const a = this.stream?.getAudioTracks?.()[0];
      if (v) v.onended = () => { this.recoverLocalTrack('video'); };
      if (a) a.onended = () => { this.recoverLocalTrack('audio'); };
    },
    async recoverLocalTrack(kind) {
      try {
        const constraints = (kind === 'video')
          ? { video: { facingMode: this.currentFacing, frameRate: { ideal: this.fps, max: this.fps } }, audio: false }
          : { audio: { noiseSuppression: this.noiseSuppression, echoCancellation: this.echoCancellation, autoGainControl: this.autoGain }, video: false };

        const newStream = await navigator.mediaDevices.getUserMedia(constraints);
        const track = (kind === 'video') ? newStream.getVideoTracks()[0] : newStream.getAudioTracks()[0];

        if (kind === 'video') {
          const old = this.stream?.getVideoTracks?.()[0];
          if (old) old.stop();
          const vlist = this.stream.getVideoTracks();
          if (vlist[0]) this.stream.removeTrack(vlist[0]);
          this.stream.addTrack(track);
          if (this.videoSender) await this.videoSender.replaceTrack(track);
        } else {
          const old = this.stream?.getAudioTracks?.()[0];
          if (old) old.stop();
          const alist = this.stream.getAudioTracks();
          if (alist[0]) this.stream.removeTrack(alist[0]);
          this.stream.addTrack(track);
          if (this.audioSender) await this.audioSender.replaceTrack(track);
        }
      } catch (e) {
        this.scheduleRestart(`recover ${kind} failed`);
      }
    },

    async startPush() {
      if (!this.liveTitle) { alert('请先输入直播标题'); return; }
      if (!this.whipUrl) { alert('请先填写 WHIP 入口 URL'); return; }
      if (this._whipCompleted || this._whipInFlight) return;

      this._whipInFlight = true;
      this.pushing = false;
      this.whipResource = '';
      this.userTerminated = false;

      try {
        let { data } = await liveroomsList(15, 1)
        let living = data.data.find(f => f.status == 1)
        // 优先用快照（复用上次 auth/roomId），否则新建
        const sess = this.loadSession();
        if (living && living.stream == sess?.roomId && sess?.auth) {
          this.auth = sess.auth;
          this.roomId = sess.roomId;
          this.whipResource = '';
        } else {
          const { data } = await createStream({ live_title: this.liveTitle, time_on: formatTime(Date.now() + 10000), time_out: formatTime(Date.now() + (3 * 24 * 60 * 60 * 1000)) });
          this.auth = data.web_rtc;
          this.roomId = data.stream_name || this.roomId;
          this.saveSession({ userTerminated: false, pushing: false });

        }

        if (this.pc) { try { this.pc.close(); } catch (_) { } }
        this.createPC();
        this.attachTrackMonitors();

        let offer = await this.pc.createOffer({ offerToReceiveAudio: false, offerToReceiveVideo: false });
        offer.sdp = forceH264Baseline(offer.sdp);
        await this.pc.setLocalDescription(offer);
        await this.waitIceComplete();

        const resp = await fetch(this.whipUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/sdp',
            'Accept': 'application/sdp',
            'X-Whip-Bearer': this.auth,
          },
          body: this.pc.localDescription.sdp
        });

        const text = await resp.text();
        const ct = resp.headers.get('content-type') || '';
        this.whipResource = resp.headers.get('location') || '';

        if (!resp.ok || (!ct.includes('application/sdp') && !text.startsWith('v='))) {
          try {
            const j = JSON.parse(text);
            if (j.errcode === -4) throw new Error('WHIP 鉴权失败：streamurl 非法。请确认使用推流域名、签名未过期、流名正确。');
            if (j.errcode === -5) {
              // 内部错误 - 重试
              await handleclearKeepLive()
              await this.retryPush();  // 执行重试
              return;
            }
            throw new Error(`WHIP失败：${resp.status} ${j.errmsg || text}`);
          } catch {
            throw new Error(`WHIP失败：${resp.status} ${text.slice(0, 200)}`);
          }
        }

        if (this.pc.signalingState === 'have-local-offer') {
          await this.pc.setRemoteDescription({ type: 'answer', sdp: text });
          this._whipCompleted = true;
        } else {
          console.warn('[WHIP] skip SRD, signalingState=', this.pc.signalingState);
        }

        // ✅ 成功后立即落会话快照（关键）
        this.saveSession({
          auth: this.auth,
          roomId: this.roomId,
          whipResource: this.whipResource,
          pushing: true,
          userTerminated: false,
        });

        this.pushing = true;
        setKeepLive(true);
        this.getCurentLiveData(this.roomId)
        if (this.statsTimer) clearInterval(this.statsTimer);
        this.statsTimer = setInterval(this.pullStatsWatchdog, 1000);

        // 业务侧状态
        try {
          await changeLiveStatus({ stream_name: this.roomId, stream_status: 1 });
        } catch (_) { }
      } catch (e) {
        console.error(e);
        await this.stopPush(); // 失败不 terminate，保留会话以便重试
      } finally {
        this._whipInFlight = false;
      }
    },

    async stopPush({ terminate = false } = {}) {
      if (this.statsTimer) { clearInterval(this.statsTimer); this.statsTimer = null; }

      if (terminate && this.whipResource) {
        try { await fetch(this.whipResource, { method: 'DELETE' }); } catch (_) { }
      }

      try { this.pc?.close(); } catch (_) { }
      this.pc = null;

      // ✅ 关键：把 sender 也置空，后面任何调用都不会误用
      this.videoSender = null;
      this.audioSender = null;

      this._whipCompleted = false;
      this._whipInFlight = false;
      this.pushing = false;

      if (terminate) {
        this.userTerminated = true;
        this.clearSession();
      } else {
        this.saveSession({ pushing: false });
      }
    },
    async retryPush() {
      try {
        // 这里可以调用stopPush先清理资源，然后重新开始推流
        await this.stopPush();
        await this.startPush();  // 尝试重新开始推流
      } catch (err) {
        console.error('重试推流失败:', err);
        alert('重试推流失败，请稍后再试');
      }
    },

    async pullStatsWatchdog() {
      if (!this.pc) return;
      try {
        const report = await this.pc.getStats(null);
        let bytes = 0, ts = 0;
        report.forEach(s => {
          if (s.type === 'outbound-rtp' && !s.isRemote && (s.kind === 'video' || s.mediaType === 'video')) {
            if (typeof s.bytesSent === 'number' && typeof s.timestamp === 'number') {
              bytes = s.bytesSent; ts = s.timestamp;
            }
          }
        });
        if (!this._lastStat) this._lastStat = { bytes, ts };
        const deltaBytes = bytes - this._lastStat.bytes;
        const deltaMs = ts - this._lastStat.ts;
        this._lastStat = { bytes, ts };
        if (deltaMs > 0) {
          const bps = (deltaBytes * 8 * 1000) / deltaMs;
          this.bitrate = bps;
          const now = Date.now();
          if (bps > 1000) {
            this.lastGoodBitrateTs = now; this.zeroBitrateSince = 0;
          } else {
            if (!this.zeroBitrateSince) this.zeroBitrateSince = now;
            if (now - this.zeroBitrateSince > 8000) this.scheduleRestart('zero bitrate > 8s');
          }
        }
        try { this.videoSender?.requestKeyFrame?.(); } catch (_) { }
      } catch (_) { }
    },

    goLive() {
      if (!this.liveTitle) { alert('请先输入直播标题'); return; }
      // ✅ 提前声明用户意图：我要继续推（除非手动结束）
      setKeepLive(true);
      this.$refs.countdown.start();
    },
    onFinished() {
      this.startPush();
    },

    async endLiveHandle() {
      if (!confirm('确定要结束直播吗？')) return;

      this.initRestartTimer()
      // 只在明确结束时，清掉“要继续推”的标记
      clearKeepLive();

      try { await changeLiveStatus({ stream_name: this.roomId, stream_status: 2 }); } catch (_) { }

      this.cancelRestart?.();
      await this.stopPush({ terminate: true });

      this.startLocalStream?.();
    },

    // —— 会话存取 —— //
    saveSession(partial = {}) {
      const prev = this.loadSession() || {};
      // 当前组件上的字段（可能为空）
      const now = {
        ts: Date.now(),
        roomId: this.roomId,
        liveTitle: this.liveTitle,
        auth: this.auth,
        whipResource: this.whipResource,
        pushing: this.pushing,
        userTerminated: this.userTerminated,
        ...partial,
      };

      // 过滤掉 null/undefined/空字符串 的键，避免把有效值覆盖成空
      const cleaned = {};
      Object.keys(now).forEach(k => {
        const v = now[k];
        if (v !== null && v !== undefined && !(typeof v === 'string' && v.trim() === '')) {
          cleaned[k] = v;
        }
      });

      const merged = { ...prev, ...cleaned };
      try { localStorage.setItem(this.sessionKey, JSON.stringify(merged)); } catch (_) { }
    },
    loadSession() {
      try {
        const raw = localStorage.getItem(this.sessionKey);
        if (!raw) return null;
        return JSON.parse(raw);
      } catch (_) {
        return null;
      }
    },
    clearSession() {
      try { localStorage.removeItem(this.sessionKey); } catch (_) { }
    },
  }
}
</script>

<style scoped>
.streaming-container {
  width: 100%;
  position: relative;
}

.video-container {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #000;
  overflow: hidden;
}

.video-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.live-indicator {
  position: absolute;
  top: 15px;
  left: 15px;
  display: flex;
  line-height: 100%;
}

.live-indicator .live-status {
  background: #e74c3c;
  color: #fff;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
}

.right-menu {
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  align-items: center;
  line-height: 100%;
}

.viewer-count {
  background: rgba(0, 0, 0, .6);
  color: #fff;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  margin-right: 10px;
}

.chat-container {
  position: fixed;
  bottom: 0px;
  left: 0;
  width: 100%;
  max-height: 60%;
  overflow-y: auto;
  font-size: 14px;
  display: flex;
  flex-direction: column-reverse;
}

.action-menu {
  position: absolute;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .2);
  z-index: 999;
  padding: 5px;
}

.livedata-tips {
  position: absolute;
  top: 50px;
  right: 0px;
  font-size: 12px;
  color: #fff;
  background: rgba(0, 0, 0, .3);
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  padding: 5px 10px;
}

.livedata-container {
  display: flex;
  width: 80%;
  height: 120px;
  justify-content: space-around;
  padding: 20px;
  color: #fff;
  position: absolute;
  top: 50px;
  left: 10%;
  animation: all .5s linear;
  background: rgba(0, 0, 0, .3);
  border-radius: 10px;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
}

.live-menu-top {
  position: absolute;
  top: 0;
  left: 0;
  padding: 15px 8px;
  width: 100%;
  color: #fff;
}

.live-info {
  display: flex;
  align-items: center;
}

.live-info .liver-avatar {
  width: 30px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  text-align: center;
  font-size: 20px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  color: #fff;
  margin-right: 5px;
}

.media-setting {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 30px;
  padding: 20px;
}

.media-setting .button-icon img {
  width: 25px;
  height: 25px;
}

.live-menu-bottom {
  position: fixed;
  bottom: 50dvh;
  left: 0;
  padding: 10px;
  width: 100%;
}

.live-menu-bottom .live-title-input {
  border: none;
  background: transparent;
  color: #fff;
  font-size: 16px;
  width: 100%;
}

.live-menu-bottom .live-title-input::placeholder {
  color: #fff;
}

.live-menu-bottom button {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  color: #fff;
  text-align: center;
  background-color: #195afc;
  font-size: 16px;
  font-weight: 600;
  border: none;
  margin-top: 20px;
}

.icon img {
  width: 25px;
  height: 25px;
}

.switch-icon {
  position: absolute;
  right: 10px;
  top: 100px;
}

.countdown-box {
  position: fixed;
  width: 50vw;
  padding: 20px;
  top: 50dvh;
  left: 25vw;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, .2);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(-50%);
}

.countdown-box .countdown-btn {
  width: 80%;
  height: 30px;
  border-radius: 15px;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  margin-top: 10px;
}
</style>
